module.exports = __webpack_public_path__ + "img/comments-question.0c940736.svg";